<template>
    <v-card :disabled="loading">
        <v-toolbar flat>
            <v-toolbar-title>Summary</v-toolbar-title>
        </v-toolbar>
        <v-list dense>
            <v-list-item>
            <v-list-item-content>Total Items:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.rows.length }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>Sub Total:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.subTotal }}
            </v-list-item-content>
            </v-list-item>
            <!--<v-list-item>
            <v-list-item-content>Item Discounts:</v-list-item-content>
            <v-list-item-content class="align-end">{{model.currency.currency}} {{model.itemDiscount}}</v-list-item-content>
            </v-list-item>-->
            <v-list-item>
            <v-list-item-content>Discounts:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.ticketDiscount }}
            </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
            <v-list-item-content>Shipping:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.shippingTotal }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>SST Pure:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.sSTTotal }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>Stamping:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.stampingTotal }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>Fitting & Misc Fees:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.fittingTotal }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>Sales Tax:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.taxTotal }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content class="title"
                >Total Due:</v-list-item-content
            >
            <v-list-item-content class="title align-end">
                {{ model.currency.currency }}
                {{ model.total }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>Funds Applied:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.fundsApplied }}
            </v-list-item-content>
            </v-list-item>
            <v-list-item>
            <v-list-item-content>Amount Remaining:</v-list-item-content>
            <v-list-item-content class="align-end">
                {{ model.currency.currency }}
                {{ model.amountRemaining }}
            </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'OrderSummary',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),
        ...mapGetters("orders",["loading"]),
        model: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    }
}
</script>

<style>

</style>